module.exports = __webpack_public_path__ + "static/media/airpodspro.d90dc6e0.webp";